import _ from "lodash";
import React from "react";

import classes from "./UnitList.scss";
import { getAttachmentUrlFromFieldValue } from "Utils";
import I18nHOC from "UIComponents/I18nHOC";
import ResourceImagePlaceHolder from "UIComponents/ResourceImagePlaceHolder";
import { EmptyState, IconButton } from "@toddle-edu/ds-web";
import {
  NoUnitFoundIllustration,
  NoSearchInFilterIllustration,
} from "@toddle-edu/ds-theme";
import { ChevronRightOutlined } from "@toddle-edu/ds-icons";

const styles = {
  newImagePlaceholder: {
    borderRadius: "8px 0px 0px 8px",
    height: "72px",
    width: "72px",
    flex: "inherit",
  },
  imagePlaceholder: {
    height: "64px",
    width: "80px",
    flex: "inherit",
  },
};

const emptyStateSubtitleStyle = {
  lineHeight: "24px",
};

class UnitList extends React.PureComponent {
  renderUnits = () => {
    const {
      props: {
        unitPlans,
        onItemClicked,
        selectedUnitId,
        searchText,
        t,
        curriculumProgramType,
      },
    } = this;

    const getGoalsAndStudentCount = unit => {
      return _.reduce(
        _.get(unit, "fields", []),
        (acc, element) => {
          const count = _.isArray(_.get(element, "value"))
            ? _.get(element, "value.length", 0)
            : 0;
          return acc + count;
        },
        0
      );
    };
    return _.get(unitPlans, "length", 0) > 0 ? (
      _.map(unitPlans, unit => {
        const planDetailStrings = [];
        const leCount = _.get(unit, "resourceLibrary.leCount", 0);
        const assessmentCount = _.get(
          unit,
          "resourceLibrary.assessmentCount",
          0
        );

        if (leCount > 0) {
          const leCountString = t("common:le_with_count", {
            count: leCount,
          });
          planDetailStrings.push(leCountString);
        }

        if (assessmentCount > 0) {
          const assessmentCountString = t("common:assessment_with_count", {
            count: assessmentCount,
          });
          planDetailStrings.push(assessmentCountString);
        }

        const imageUrl = getAttachmentUrlFromFieldValue({
          fieldValue: _.get(unit, "image", ""),
        });

        const learningGoalsCount = getGoalsAndStudentCount(unit);
        const handleItemClicked = unit => {
          return () => {
            onItemClicked(unit);
          };
        };
        return (
          <React.Fragment key={_.get(unit, "id")}>
            <div
              onClick={handleItemClicked(unit)}
              className={classes.singleUnitItemContainer}
              key={_.get(unit, "id")}
            >
              <div className={classes.unitAvatar}>
                <ResourceImagePlaceHolder
                  id={unit.id}
                  imageUrl={imageUrl}
                  imageThumbSize={56}
                  containerStyle={styles.newImagePlaceholder}
                />
              </div>
              <div className={classes.unitDetailsContainer}>
                <div className={classes.unitTitle}>
                  {_.get(unit, "title.value")}
                </div>
                <div className={classes.resourceCentralIdea}>
                  {t("journal:learning_goals_count", {
                    count: learningGoalsCount,
                  })}
                </div>
              </div>
              <IconButton
                icon={<ChevronRightOutlined />}
                variant={"plain"}
                size={"medium"}
              />
            </div>
          </React.Fragment>
        );
      })
    ) : _.get(searchText, "length", 0) > 0 ? (
      <div className={classes.noDataContainer}>
        <EmptyState
          illustration={NoSearchInFilterIllustration}
          title={t("common:noResultHeading")}
          subtitle={t("common:no_items_matching_your_search")}
          subtitleStyle={emptyStateSubtitleStyle}
          size="small"
        />
      </div>
    ) : (
      <div className={classes.noDataContainer}>
        <EmptyState
          illustration={NoUnitFoundIllustration}
          size="small"
          title={
            curriculumProgramType == "IB_PYP"
              ? t("journal:no_unit_scheduled")
              : t("journal:no_units")
          }
          subtitle={t("journal:create_unit_and_learning_goals")}
          subtitleStyle={emptyStateSubtitleStyle}
        />
      </div>
    );
  };

  render() {
    const { t, onSelectFromAllPYP, selectFromAllPYP } = this.props;

    return (
      <div className={classes.listContainer}>
        <div className={classes.listContent}>{this.renderUnits()}</div>
      </div>
    );
  }
}

export default I18nHOC({ resource: ["common", "journal"] })(UnitList);
